// Unified reactions configuration for Unity Love
// Used across Chat, Lounge, Video Room, and any other messaging contexts
//
// Ordered: 😍❤️🔥😂😅🤯🥵💦🍆😈
// Unity Love signature "spicy" edition

export const REACTIONS = [
  { key: "heart_eyes", emoji: "😍", label: "Crush" },
  { key: "heart", emoji: "❤️", label: "Love" },
  { key: "fire", emoji: "🔥", label: "Fire" },
  { key: "laugh", emoji: "😂", label: "Funny" },
  { key: "nervous", emoji: "😅", label: "Haha" },
  { key: "mind_blown", emoji: "🤯", label: "Mind blown" },
  { key: "hot", emoji: "🥵", label: "Too Hot" },
  { key: "splash", emoji: "💦", label: "Yesss" },
  { key: "eggplant", emoji: "🍆", label: "Spicy" },
  { key: "devil", emoji: "😈", label: "Naughty" },
];

/**
 * Helper to normalize reaction counts from backend shape
 * 
 * Expected backend shapes:
 * - { "😍": ["userId1", "userId2"], "🔥": ["userId3"] }
 * - { "😍": 2, "🔥": 1 }
 * - { "heart_eyes": ["userId1", "userId2"], "fire": ["userId3"] }
 * 
 * Returns:
 * [{ key: "heart_eyes", emoji: "😍", label: "Crush", count: 2 }, ...]
 */
export function getReactionCounts(rawReactions = {}) {
  const counts = [];

  for (const { emoji, key, label } of REACTIONS) {
    const value = rawReactions[emoji] ?? rawReactions[key];
    let count = 0;

    if (Array.isArray(value)) {
      count = value.length;
    } else if (typeof value === "number") {
      count = value;
    }

    if (count > 0) {
      counts.push({ emoji, key, label, count });
    }
  }

  return counts;
}
